export const APP_NAME = 'Redgaady';

export const APP_BRAND = {
  name: APP_NAME,
  logoSrc: '/redgaady-logo.jpg',
  logoAlt: `${APP_NAME} logo`,
};

export const ROUTES = {
  home: '/',
  login: '/login',
  signup: '/signup',
  emailVerification: '/account/verify-email',
  phoneVerification: '/account/verify-phone',
  dashboard: '/dashboard',
  orders: '/dashboard/orders',
  checkout: '/dashboard/checkout',
  customerWallet: '/dashboard/wallet',
  deliveryFinance: '/dashboard/payments/:deliveryId',
  accountClosure: '/dashboard/account-closure',
  paymentSuccess: '/dashboard/payment-success',
  adminLogin: '/admin/login',
  adminDashboard: '/admin/dashboard',
  driverLogin: '/driver/login',
  driverSignup: '/driver/signup',
  driverWallet: '/driver/wallet',
  driverDashboard: '/driver/dashboard',
  bookVehicle: '/book/vehicle',
  bookEstimate: '/book/estimate',
};
